const deviceHeight = window.innerHeight;

const BASE_HEIGHT = 800;

export const normalizeText = (size: number): number => {
  const ratio = deviceHeight / BASE_HEIGHT;
  return Math.round(size * ratio);
};
